import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import images from "../../../utilities/images/images";
import "./AitsTestInstruction.css";

import HeaderInstruction from "../components/Instruction/HeaderInstruction";

function AitsTestInstruction() {
  const history = useHistory();
  const { instructions,testDetails } = useSelector((state) => state.examSlice);
  const source = testDetails?.source;
const selectedMode = testDetails?.practiceMode;
  const inst = instructions?.instruction || instructions;
  const attempt_text = inst?.attempt_text;
const durationValue = inst?.duration_time || inst?.duration_mins;
const hideDuration = !durationValue;
  return (
    <div className="aitstest_instruction">
      <div className="test_container">
        <img
          src={images.new_backarrow}
          alt="back"
          className="arrow_image"
          // onClick={() => history.push("/practice/paper-listing")}
          onClick={() => {
  if (source === "topicwise") {
    history.push("/practice/topic-wise/pyqset");
  } else if (source === "yearwise") {
    history.push("/practice/paper-listing?type=Year Wise");
  } else {
    history.push("/practice/paper-listing");
  }
}}

        />
        <span>Test Instruction</span>
      </div>

      <div className="common_padding">
        <HeaderInstruction
          name={inst?.paper_name}
          type={inst?.paper_type}
          duration={inst?.duration_mins}
          totalQuestions={inst?.total_questions}
          maxMarks={inst?.max_marks}
          date={inst?.start_date}
          instruction_image={`https://learning.motion.ac.in${inst?.instructions_image}`}
          paper_icon={inst?.paper_icon}
          duration_icon={inst?.duration_icon}
          question_icon={inst?.question_icon}
           hideDuration={hideDuration}
        />
        {attempt_text && selectedMode === "test" && (
  <div className="reattemptInfoContainer">
    <div className="reattemptRow">
      <span className="reattemptInfo">
        Attempts used:
      </span>

      <span className="attemptBadge">
        {attempt_text?.attempt_count}/
        {attempt_text?.total_attempt_count}
      </span>
    </div>

    <div className="reattemptSubtext">
      {attempt_text?.attempt_message}
    </div>
  </div>
)}

        {(inst?.test_instruction_eng || inst?.instructions_html) && (
  <div className="general_wrapper">
    <div className="general_header">General Instructions</div>

    <div
      className="general_content instructions_html_container"
      dangerouslySetInnerHTML={{
        __html:
          inst?.test_instruction_eng ||
          inst?.instructions_html,
      }}
    />
  </div>
)}

        <div className="start_btn">
          <button
            className="back-tests-btn"
            // onClick={() => history.push("/paper-listing")}
            onClick={() => {
  if (source === "topicwise") {
    history.push("/practice/topic-wise/pyqset");
  } else if (source === "yearwise") {
    history.push("/practice/paper-listing?type=Year Wise");
  } else {
    history.push("/practice/paper-listing");
  }
}}
          >
            Back
          </button>

          <button
            className="begin-test-btn"
            // onClick={() =>
            //   history.push("/test", {
            //     paperId: inst?.paper_id,
            //     paperType: inst?.paper_type,
            //   })
            // }
            onClick={() => {
  if (source === "topicwise") {
    history.push("/test", {
      paperType: inst?.paper_type,
      setId: inst?.set_id,
      // practiceMode: "practice",
    });
  } else {
    history.push("/test", {
      paperId: inst?.paper_id,
      paperType: inst?.paper_type,
      testId: inst?.test_id,
    });
  }
}}
          >
            <span>Begin Your Test</span>
            <img
              src={images.rightArrow_icon}
              alt="arrow"
              className="arrow-icon"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default AitsTestInstruction;
